import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import * as cls from "./payment.module.scss";
import Loader from "../../components/loader/Loader";
import ModalPaymentStatus from "../../components/modalPaymentStatus/ModalPaymentStatus";
import { StudentService } from "../../components/studentService";
import {
  ErrataWidget,
  WidgetFrame,
} from "../../../personal-studio-components/studio";

function OrderMaking() {
  const [selectedOption, setSelectedOption] = useState("me");
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [sendStatus, setSendStatus] = useState(null);
  const [response, setResponse] = useState(null);

  async function orderSend() {
    if (access_token && selectedOption) {
      setSendStatus("inProcess");
      const is_represent = selectedOption === "representative";
      const request = {
        method: "post",
        path: "/student/payment/order/send",
        data: {
          access_token,
          study_contract_id: contractId,
          is_represent,
        },
      };
      const data = await StudentService.send(request, setResponse);
      if (!data.errors) {
        setSendStatus("success");
      } else if (data.error_type === "auth") {
        const err = data.errors;
        const errorEvent = new ErrorEvent("error", { error: err });
        window.dispatchEvent(errorEvent);
        setSendStatus(null);
      }
      // setSelectedOption(null);
    }
  }

  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };
  if (response?.errors) return <ErrataWidget errata={response} />;

  return (
    <WidgetFrame type="blue" icon="survey" title="Оформление квитанции">
      <label className={cls.note}>*Форма квитанции</label>
      <label className={cls.whosName}>
        <input
          type="radio"
          name="paymentOption"
          checked={selectedOption === "me"}
          onChange={() => handleOptionChange("me")}
        />
        На мое имя
      </label>
      <label className={cls.whosName}>
        <input
          type="radio"
          name="paymentOption"
          checked={selectedOption === "representative"}
          onChange={() => handleOptionChange("representative")}
        />
        На представителя
      </label>
      <div>
        {sendStatus === "inProcess" ? (
          <Loader />
        ) : (
          <button onClick={orderSend} className={cls.button_bright}>
            Сформировать квитанцию
          </button>
        )}
      </div>
      <ModalPaymentStatus
        sendStatus={sendStatus}
        setSendStatus={setSendStatus}
      />
    </WidgetFrame>
  );
}

export default OrderMaking;
